import { Measurement } from './_types';

export const LIB_MEASURES_HARVEST_PATHOLOGY : Measurement[] = [
    {
        id: "frut_pathology_alter",
        unit: "%",
        label: "Alternaria",
        tag: "ALT",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_alt_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_asper",
        unit: "%",
        label: "Aspergillus rot",
        tag: "ASP",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_asp_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_peni",
        unit: "%",
        label: "Penicillium rot",
        tag: "PEN",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_pen_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_bot",
        unit: "%",
        label: "Botrytis grey mold",
        tag: "BOT",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_bot_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_rhi",
        unit: "%",
        label: "Rhizopus rot",
        tag: "RHI",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_rhi_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_collet",
        unit: "%",
        label: "Colletotrichum rot",
        tag: "COL",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_col_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_clado",
        unit: "%",
        label: "Cladosporium rot",
        tag: "CLA",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_cla_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_cera",
        unit: "%",
        label: "Ceratocystis rot",
        tag: "CER",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_cer_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_phomo",
        unit: "%",
        label: "Phomopsis rot",
        tag: "PHO",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_pho_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
    {
        id: "frut_pathology_gene",
        unit: "%",
        label: "Generic rot",
        tag: "GEN",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_pathology_gen_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_pathology",
    },
];